/* ============================================================================
   Atelier Diamante — Jewelry PDP (ad-product-jewelry)  AD-PJ v1.1
   Self-contained Alpine component for finished-jewelry product pages.
   - Media gallery (video-first) with active-item switching
   - Lazy video: only plays on demand; pauses others on switch
   - Accordions (details / shipping / care)
   - Add-to-cart via the same /cart/add.js flow used store-wide
   ========================================================================== */
document.addEventListener('alpine:init', () => {
  Alpine.data('adProductJewelry', () => ({
    active: 0,
    adding: false,
    added: false,
    cartError: '',
    expanded: { details: true, shipping: false, care: false },

    /* AD-PJ v1.1 — variant picker state */
    sel: [],
    variants: null,
    priceText: '',
    unavailable: false,

    init() {
      const el = this.$root.querySelector('[data-pj-variants]');
      if (el) { try { this.variants = JSON.parse(el.textContent).v; } catch (e) { this.variants = null; } }
      this.$root.querySelectorAll('.ad-pj__opt-select').forEach((s, i) => { this.sel[i] = s.value; });
      const initial = this.$root.querySelector('.ad-pj__price');
      if (initial) this.priceText = initial.textContent.trim();
      this.syncVariant();
    },

    /* Resolve selected options -> variant id, price, availability */
    syncVariant() {
      if (!this.variants || !this.sel.length) return;
      const hit = this.variants[this.sel.join('|')];
      if (hit) {
        this.$root.dataset.variantId = String(hit[0]);
        this.priceText = '$' + Math.round(hit[1] / 100).toLocaleString('en-US');
        this.unavailable = !hit[2];
      } else {
        this.unavailable = true;
      }
    },

    /* Switch the main stage; pause any playing video so audio/video don't bleed */
    setActive(i) {
      this.active = i;
      this.$nextTick(() => {
        this.$root.querySelectorAll('video').forEach((v) => { try { v.pause(); } catch (e) {} });
      });
    },

    toggle(key) { this.expanded[key] = !this.expanded[key]; },

    /* Reserve / add to bag — same cart flow as the rest of the store */
    async addToCart() {
      const id = this.$root.dataset.variantId;
      if (!id || this.adding) return;
      this.adding = true;
      this.cartError = '';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(id), quantity: 1 })
        });
        if (!res.ok) {
          let msg = 'This piece could not be reserved right now.';
          try { const j = await res.json(); if (j && j.description) msg = j.description; } catch (e) {}
          throw new Error(msg);
        }
        this.added = true;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.location.href = '/cart';
      } catch (err) {
        this.adding = false;
        this.cartError = (err && err.message) || 'Something went wrong. Please try again or contact us.';
      }
    }
  }));
});
